import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsTitle = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-title", { ref: ref }, children));
};
export default VeltNotificationsPanelSettingsTitle;
